import Lenis from "lenis";

let lenis = null;

export function initLenis() {
    if (lenis) return lenis;
    lenis = new Lenis({
        duration: 1.15,
        smoothWheel: true,
        touchMultiplier: 1.4,
    });
    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return lenis;
}

export function getLenis() {
    return lenis;
}

export function scrollToId(id, offset = -84) {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenis) {
        lenis.scrollTo(el, { offset, duration: 1.25 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}
